enum PublishRequestFilter {
  All = 0,
  CreatedByMe = 1,
  WaitingOnMe = 2
}

export default PublishRequestFilter;
